import { render, staticRenderFns } from "./cmp-tags-cell-renderer.vue?vue&type=template&id=64f1c528&scoped=true&"
import script from "./cmp-tags-cell-renderer.vue?vue&type=script&lang=ts&"
export * from "./cmp-tags-cell-renderer.vue?vue&type=script&lang=ts&"
import style0 from "./cmp-tags-cell-renderer.vue?vue&type=style&index=0&id=64f1c528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f1c528",
  null
  
)

/* custom blocks */
import block0 from "./cmp-tags-cell-renderer.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports